import React, { useState } from 'react';
import { Toolbar, Grid, Button, Popper } from '@material-ui/core';

import { Link, withRouter } from 'react-router-dom';


import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import NotificationsIcon from '@material-ui/icons/Notifications';
import InfluencerLogo from '../../assets/influencer-logo.png';
import { connect } from 'react-redux';

import { colorConstants } from '../../constants/colors';

function MobileNavBar(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);

  const logOut = () => {
    try {
      window.FB.api('/me/permissions', 'delete', null, () => window.FB.logout());
    } catch {}

    for (const key of ['access', 'refresh', 'user']) localStorage.removeItem(key);
    window.location = '/login';
  };

  const user = JSON.parse(localStorage.getItem('user'));
  const name = user.user_type === 'brand' ? user.brand.name : user.influencer.name;
  return props.location.pathname === '/influencer/profile-setup' ? (
    ''
  ) : (
    <Toolbar className={'navbar-outer'}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ width: '92vw' }}
      >
        <Grid item md={6}>
          <Link to="/influencer/campaigns">
            <img
              src={InfluencerLogo}
              alt="influencer-logo"
              width={'80px'}
              // height={'40px'}
            ></img>
          </Link>
        </Grid>
        <Grid item md={6} style={{ fontSize: '12px' }}>
          <Grid container direction="row" justify="flex-end">
            <Grid item style={{ visibility: 'hidden' }}>
              <NotificationsIcon />
            </Grid>
            <Grid item>
              <Grid container justify="space-evenly" alignItems="flex-start">
                <Grid item style={{ paddingTop: 2 }}>
                  Hi, {name}!
                </Grid>
                <Grid item>
                  <PersonOutlineIcon onClick={handleClick} />
                  <Popper open={open} anchorEl={anchorEl}>
                    <Button
                      variant="contained"
                      style={{
                        marginTop: '20px',
                        backgroundColor: colorConstants.TEXT_BLUE,
                        color: 'white',
                      }}
                      onClick={logOut}
                    >
                      Logout
                    </Button>
                  </Popper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
}

const mapStateToProps = (state) => ({
  loading: state.campaign.loading,
  user: state.auth.user,
});

export default connect(mapStateToProps, {})(withRouter(MobileNavBar));
